import React from 'react';
import { FadeIn } from './FadeIn';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
export function FAQSection() {
  const faqs = [{
    q: '¿Cómo recibo el material?',
    a: 'El acceso es inmediato. Una vez confirmado el pago, recibirás un email con tus credenciales para acceder a todo el material y los bonos de por vida.'
  }, {
    q: '¿Se puede pagar en cuotas?',
    a: 'Sí, a través de Mercado Pago podés financiar tu compra con las tarjetas habilitadas en la plataforma.'
  }, {
    q: '¿Sirve para celíacos/veganos?',
    a: 'Sí, absolutamente. El Método 6:30 es un sistema de logística y organización. Las técnicas de preparación y congelado son adaptables a cualquier ingrediente o restricción alimentaria.'
  }, {
    q: '¿Necesito un freezer grande?',
    a: 'No. El sistema incluye técnicas de empaque plano y organización que maximizan el espacio. Funciona incluso con el freezer de una heladera estándar de departamento.'
  }, {
    q: '¿Cuánto tiempo duran las comidas congeladas?',
    a: 'Con las técnicas del Método 6:30, tus comidas mantienen su sabor y textura original por hasta 3 meses. El Tomo II incluye una guía detallada de tiempos de conservación por tipo de alimento.'
  }, {
    q: '¿Necesito experiencia en la cocina?',
    a: 'Para nada. Las recetas están diseñadas para cualquier nivel. Cada paso está explicado de forma simple y clara, con tiempos y cantidades exactas. Si sabés hervir agua, podés usar el sistema.'
  }];
  return <section className="bg-[#F5F5F5] py-10 md:py-16 px-4 md:px-8" data-id="element-46">
      <div className="max-w-3xl mx-auto" data-id="element-47">
        <FadeIn data-id="element-48">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-5 md:mb-8" data-id="element-49">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-2 md:space-y-3" data-id="element-50">
          {faqs.map((faq, index) => <FadeIn key={index} delay={0.05 * index} data-id="element-51">
              <Accordion sx={{
            borderRadius: '12px !important',
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
            '&:before': {
              display: 'none'
            },
            mb: 1
          }} data-id="element-52">
                <AccordionSummary expandIcon={<ExpandMoreIcon className="text-[#2D5A27]" data-id="element-54" />} sx={{
              px: 3,
              py: 1
            }} data-id="element-53">
                  <h3 className="text-lg font-bold text-gray-900" data-id="element-55">{faq.q}</h3>
                </AccordionSummary>
                <AccordionDetails sx={{
              px: 3,
              pb: 3,
              pt: 0
            }} data-id="element-56">
                  <p className="text-gray-600 text-lg leading-relaxed" data-id="element-57">
                    {faq.a}
                  </p>
                </AccordionDetails>
              </Accordion>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}